import store from '../../stores';

export default class Mock {
  static call(returnedData) {
    return new Promise((resolve) => {
      store.commit('loading/viewPending', true);
      setTimeout(() => {
        store.commit('loading/viewPending', false);
        return resolve({ data: returnedData });
      }, 1000);
    });
  }
}
